"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var js_cookie_1 = __importDefault(require("js-cookie"));
var ISSOConfig_1 = require("./ISSOConfig");
// @ts-ignore
var authUtils_1 = require("../utils/authUtils");
var AjaxModule = /** @class */ (function () {
    function AjaxModule(params) {
        this.ajaxFuncs = {};
        this.respCached = {};
        this.ajaxParams = params;
        this.unLoginCode = params.unLoginCode || 101;
        axios_1.default.defaults.baseURL = params.baseURL || "";
        if (params.appendExpelParams)
            this.appendExpelParams = params.appendExpelParams;
        // 添加一个请求拦截器
        var that = this;
        var domain = document.domain != 'localhost' ? document.domain : 'localhost';
        axios_1.default.interceptors.request.use(function (config) {
            // Do something before request is sent
            var authString = window.localStorage.getItem(ISSOConfig_1.ETokenName.authorizationKey) || js_cookie_1.default.get(ISSOConfig_1.ETokenName.authorizationKey);
            var USAuthString = window.localStorage.getItem("usToken") || js_cookie_1.default.get(ISSOConfig_1.ETokenName.accountTokenKey) || "";
            var topLevel = domain != 'localhost' ? Array(1).concat(document.domain.split('.').slice(-2)).join('.') : '';
            // config.headers[ETokenName.authorizationKey] = authString;
            // if (null == authString || authString == "" || config.url === '/token') {
            //     config.headers[ETokenName.accountTokenKey] = USAuthString;
            //     Reflect.deleteProperty(config.headers, ETokenName.authorizationKey);
            //     if (USAuthString == "" && (window.location.href.indexOf("sessionId=") < 0 && window.location.href.indexOf("sign=") < 0)) {
            //         let targetURL= params.loginAddress + "?callback=" +
            //             encodeURIComponent(window.location.href);    //回调url encode;
            //         const paramsFormatted = that.ajaxParams.beforeExpel ? that.ajaxParams.beforeExpel(config) : true;
            //         // beforeExpel === false 时候 不跳转，否则都跳转
            //         // undefined {} {dafd: 9} === false, 不跳转，否则都跳转
            //         if(paramsFormatted !== false) {
            //             if(typeof paramsFormatted == 'object' && !(paramsFormatted instanceof Array)) {
            //                 for(let key in paramsFormatted) {
            //                     targetURL += '&' + key + '=' + paramsFormatted[key];
            //                 }
            //             }
            //             // without accountTokenKey and authorizationKey, api response will guide to login ...
            //             Cookies.remove(ETokenName.accountTokenKey);
            //             // 清除顶级域名残留cookie的影响
            //             !!topLevel ? Cookies.remove(ETokenName.authorizationKey, {domain: topLevel}) : '';
            //             Cookies.remove(ETokenName.authorizationKey);
            //             Cookies.remove(ETokenName.authorizationKey, {domain});
            //             localStorage.removeItem('usToken');
            //             window.localStorage.removeItem("usToken");
            //             window.location.href = targetURL;
            //         }
            //     }
            // }
            if (config.url === '/logout') {
                config.headers[ISSOConfig_1.ETokenName.accountTokenKey] = USAuthString;
            }
            // config.headers["appid"] = params.APPID || "";
            config.headers["system-code"] = process.env.VUE_APP_SYSTEM_CODE;
            config.headers["Authorization"] = "Bearer ".concat(localStorage.getItem('usToken'));
            if (params.requestHandler) {
                var tmpConf = params.requestHandler(config);
                if (tmpConf) {
                    config = tmpConf;
                }
            }
            return config;
        });
        // 添加一个响应拦截器
        axios_1.default.interceptors.response.use(function (response) {
            // Do something with response data
            that.handleResponse(response);
            if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                return Promise.reject(response);
            }
            if (params.responseHandler) {
                var tmpResult = params.responseHandler(response.data);
                if (tmpResult)
                    response.data = tmpResult;
            }
            return response;
        });
    }
    AjaxModule.prototype.getAxiosTarget = function () {
        return axios_1.default;
    };
    AjaxModule.prototype.pathParamsResolver = function (url, params) {
        if (!url.split("/").some(function (path) { return !path.startsWith(":"); }) || !params) {
            return { url: url, params: params };
        }
        // 不包含简单类型参数
        // let nonSimple = Object.values(params).every(val => ['undefined', 'object', 'function'].includes(typeof(val)));
        // if(nonSimple){return {url, params}; }
        var paramsCopy = Object.assign({}, params);
        url = url.split("/").map(function (path) {
            var keyTmp = path.replace(":", "");
            if (!path || !path.startsWith(':') || !(keyTmp in params) || 'undefined-object-function'.split("-").includes(typeof (params[keyTmp]))) {
                return path;
            }
            Reflect.deleteProperty(params, keyTmp);
            return paramsCopy[keyTmp];
        }).join("/");
        return { url: url, params: params };
    };
    AjaxModule.prototype.getURL = function (url, prefixUrl) {
        var _a, _b, _c;
        var tmpURL = "", cache = false, type = "get";
        if (typeof url == "function") {
            var urlResult = url();
            tmpURL = urlResult.url;
            type = urlResult.type || "get";
        }
        else {
            var mts = (_c = (_b = (_a = url === null || url === void 0 ? void 0 : url.replace(/[\s]+/g, ' ')) === null || _a === void 0 ? void 0 : _a.trim()) === null || _b === void 0 ? void 0 : _b.match(/^((?:get|post|delete|put|patch) )?((?:cache) )?(.+)$/i)) === null || _c === void 0 ? void 0 : _c.map(function (i) { return !!i ? i.trim() : i; });
            type = (((mts === null || mts === void 0 ? void 0 : mts[1]) || 'get').toLocaleLowerCase());
            cache = !!(mts === null || mts === void 0 ? void 0 : mts[2]);
            tmpURL = (mts === null || mts === void 0 ? void 0 : mts[3]) || '';
        }
        var prefix = prefixUrl && prefixUrl != "" ? prefixUrl : this.ajaxParams.appPrefix || "";
        return { url: prefix + tmpURL, type: type, cache: cache };
    };
    AjaxModule.prototype.ajaxFunc = function (tmpURL, prefixUrl) {
        var self = this;
        var _a = self.getURL(tmpURL, prefixUrl), url = _a.url, type = _a.type, cache = _a.cache;
        var ajaxTarget = {
            'get': function (params, _otherConf, urlReducer) {
                var otherConf = {};
                if (typeof _otherConf == "function") {
                    urlReducer = _otherConf;
                }
                else {
                    otherConf = _otherConf ? _otherConf : {};
                }
                var tmpURL = url;
                if (urlReducer) {
                    tmpURL = urlReducer(tmpURL);
                }
                if (!params) {
                    params = {};
                }
                var adequateConf = self.pathParamsResolver(tmpURL, params);
                tmpURL = adequateConf.url;
                params = adequateConf.params;
                return new Promise(function (resolve, reject) {
                    var httpUUID = !cache ? '' : self.md5(JSON.stringify(__assign({ method: 'get', url: tmpURL, data: params }, otherConf)));
                    if (!!httpUUID && httpUUID in self.respCached) {
                        resolve(self.respCached[httpUUID]);
                        return;
                    }
                    if (!('_' in params) && !('preventCache' in params)) {
                        params['_'] = String(Math.random()).slice(-6);
                    }
                    return axios_1.default.get(tmpURL, __assign({ params: params }, otherConf)).then(function (response) {
                        var _a;
                        if (!!cache && (response === null || response === void 0 ? void 0 : response.status) == 200 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) == 0) {
                            self.respCached[httpUUID] = response.data;
                        }
                        if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                            reject(response);
                        }
                        resolve(response.data);
                    }).catch(function (error) {
                        self.handleResponse(error.response);
                        reject(error);
                    });
                });
            },
            'post': function (params, _otherConf, urlReducer) {
                var otherConf = {};
                if (typeof _otherConf == "function") {
                    urlReducer = _otherConf;
                }
                else {
                    otherConf = _otherConf ? _otherConf : {};
                }
                var tmpURL = url;
                if (urlReducer) {
                    tmpURL = urlReducer(tmpURL);
                }
                var adequateConf = self.pathParamsResolver(tmpURL, params);
                tmpURL = adequateConf.url;
                params = adequateConf.params;
                return new Promise(function (resolve, reject) {
                    var httpUUID = !cache ? '' : self.md5(JSON.stringify(__assign({ method: 'post', url: tmpURL, data: params }, otherConf)));
                    if (!!httpUUID && httpUUID in self.respCached) {
                        resolve(self.respCached[httpUUID]);
                        return;
                    }
                    return (0, axios_1.default)(__assign({ method: 'post', url: tmpURL, data: params }, otherConf)).then(function (response) {
                        var _a;
                        if (!!cache && (response === null || response === void 0 ? void 0 : response.status) == 200 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) == 0) {
                            self.respCached[httpUUID] = response.data;
                        }
                        if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                            reject(response);
                        }
                        resolve(response.data);
                    }).catch(function (error) {
                        self.handleResponse(error.response);
                        reject(error);
                    });
                });
            },
            'delete': function (params, _otherConf, urlReducer) {
                var otherConf = {};
                if (typeof _otherConf == "function") {
                    urlReducer = _otherConf;
                }
                else {
                    otherConf = _otherConf ? _otherConf : {};
                }
                var tmpURL = url;
                if (urlReducer) {
                    tmpURL = urlReducer(tmpURL);
                }
                var adequateConf = self.pathParamsResolver(tmpURL, params);
                tmpURL = adequateConf.url;
                params = adequateConf.params;
                return new Promise(function (resolve, reject) {
                    axios_1.default.delete(tmpURL, __assign({ data: params }, otherConf)).then(function (response) {
                        if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                            resolve(response.data);
                        }
                        reject(response);
                    }).catch(function (error) {
                        self.handleResponse(error.response);
                        reject(error);
                    });
                });
            },
            'put': function (params, _otherConf, urlReducer) {
                var otherConf = {};
                if (typeof _otherConf == "function") {
                    urlReducer = _otherConf;
                }
                else {
                    otherConf = _otherConf ? _otherConf : {};
                }
                var tmpURL = url;
                if (urlReducer) {
                    tmpURL = urlReducer(tmpURL);
                }
                var adequateConf = self.pathParamsResolver(tmpURL, params);
                tmpURL = adequateConf.url;
                params = adequateConf.params;
                return new Promise(function (resolve, reject) {
                    axios_1.default.put(tmpURL, __assign({}, params), __assign({}, otherConf)).then(function (response) {
                        if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                            resolve(response.data);
                        }
                        reject(response);
                    }).catch(function (error) {
                        self.handleResponse(error.response);
                        reject(error);
                    });
                });
            },
            'patch': function (params, _otherConf, urlReducer) {
                var otherConf = {};
                if (typeof _otherConf == "function") {
                    urlReducer = _otherConf;
                }
                else {
                    otherConf = _otherConf ? _otherConf : {};
                }
                var tmpURL = url;
                if (urlReducer) {
                    tmpURL = urlReducer(tmpURL);
                }
                var adequateConf = self.pathParamsResolver(tmpURL, params);
                tmpURL = adequateConf.url;
                params = adequateConf.params;
                return new Promise(function (resolve, reject) {
                    axios_1.default.patch(tmpURL, __assign({}, params), __assign({}, otherConf)).then(function (response) {
                        if ((response === null || response === void 0 ? void 0 : response.status) == 200) {
                            resolve(response.data);
                        }
                        reject(response);
                    }).catch(function (error) {
                        self.handleResponse(error.response);
                        reject(error);
                    });
                });
            }
        }[type];
        return ajaxTarget;
    };
    AjaxModule.prototype.handleResponse = function (response) {
        var _a, _b, _c;
        var domain = document.domain != 'localhost' ? document.domain : 'localhost';
        var topLevel = domain != 'localhost' ? Array(1).concat(document.domain.split('.').slice(-2)).join('.') : '';
        if (([401, 402].indexOf(response === null || response === void 0 ? void 0 : response.status) >= 0) || ((response === null || response === void 0 ? void 0 : response.status) == 200 && ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.code) == this.unLoginCode || ([401, 402].indexOf((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.code) >= 0))) {
            // 登录过期，重新登录
            (0, authUtils_1.logout)();
            // let targetURL = params.loginAddress + "?redirect_uri=" + encodeURIComponent(window.location.href) + "&system=" + (params.SYSTEM || "");
            // const paramsFormatted = that.ajaxParams.beforeExpel ? that.ajaxParams.beforeExpel(response) : true;
            // // beforeExpel === false 时候 不跳转，否则都跳转
            // // undefined {} {dafd: 9}  === false, 不跳转，否则都跳转
            // if(paramsFormatted !== false) {
            //     if(typeof paramsFormatted == 'object' && !(paramsFormatted instanceof Array)) {
            //         for(let key in paramsFormatted) {
            //             targetURL += '&' + key + '=' + paramsFormatted[key];
            //         }
            //     }
            //     // without accountTokenKey and authorizationKey, api response will guide to login ...
            //     Cookies.remove(ETokenName.accountTokenKey);
            //     // 清除顶级域名残留cookie的影响
            //     !!topLevel ? Cookies.remove(ETokenName.authorizationKey, {domain: topLevel}) : '';
            //     Cookies.remove(ETokenName.authorizationKey);
            //     Cookies.remove(ETokenName.authorizationKey, {domain});
            //     localStorage.removeItem('usToken');
            //     window.localStorage.removeItem("usToken");
            //     window.location.href = targetURL;
            // }
        }
        if ((response === null || response === void 0 ? void 0 : response.status) === 403 || ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.code) === 403) {
            if (window.location.href.indexOf('/no-permission') < 0) {
                window.location.href = "".concat(window.location.origin, "/no-permission");
            }
        }
    };
    //  Formatted version of a popular md5 implementation
    //  Original copyright (c) Paul Johnston & Greg Holt.
    AjaxModule.prototype.md5 = function (inputString) {
        var hc = "0123456789abcdef";
        function rh(n) { var j, s = ""; for (j = 0; j <= 3; j++)
            s += hc.charAt((n >> (j * 8 + 4)) & 0x0F) + hc.charAt((n >> (j * 8)) & 0x0F); return s; }
        function ad(x, y) { var l = (x & 0xFFFF) + (y & 0xFFFF); var m = (x >> 16) + (y >> 16) + (l >> 16); return (m << 16) | (l & 0xFFFF); }
        function rl(n, c) { return (n << c) | (n >>> (32 - c)); }
        function cm(q, a, b, x, s, t) { return ad(rl(ad(ad(a, q), ad(x, t)), s), b); }
        function ff(a, b, c, d, x, s, t) { return cm((b & c) | ((~b) & d), a, b, x, s, t); }
        function gg(a, b, c, d, x, s, t) { return cm((b & d) | (c & (~d)), a, b, x, s, t); }
        function hh(a, b, c, d, x, s, t) { return cm(b ^ c ^ d, a, b, x, s, t); }
        function ii(a, b, c, d, x, s, t) { return cm(c ^ (b | (~d)), a, b, x, s, t); }
        function sb(x) {
            var i;
            var nblk = ((x.length + 8) >> 6) + 1;
            var blks = new Array(nblk * 16);
            for (i = 0; i < nblk * 16; i++)
                blks[i] = 0;
            for (i = 0; i < x.length; i++)
                blks[i >> 2] |= x.charCodeAt(i) << ((i % 4) * 8);
            blks[i >> 2] |= 0x80 << ((i % 4) * 8);
            blks[nblk * 16 - 2] = x.length * 8;
            return blks;
        }
        var i, x = sb("" + inputString), a = 1732584193, b = -271733879, c = -1732584194, d = 271733878, olda, oldb, oldc, oldd;
        for (i = 0; i < x.length; i += 16) {
            olda = a;
            oldb = b;
            oldc = c;
            oldd = d;
            a = ff(a, b, c, d, x[i + 0], 7, -680876936);
            d = ff(d, a, b, c, x[i + 1], 12, -389564586);
            c = ff(c, d, a, b, x[i + 2], 17, 606105819);
            b = ff(b, c, d, a, x[i + 3], 22, -1044525330);
            a = ff(a, b, c, d, x[i + 4], 7, -176418897);
            d = ff(d, a, b, c, x[i + 5], 12, 1200080426);
            c = ff(c, d, a, b, x[i + 6], 17, -1473231341);
            b = ff(b, c, d, a, x[i + 7], 22, -45705983);
            a = ff(a, b, c, d, x[i + 8], 7, 1770035416);
            d = ff(d, a, b, c, x[i + 9], 12, -1958414417);
            c = ff(c, d, a, b, x[i + 10], 17, -42063);
            b = ff(b, c, d, a, x[i + 11], 22, -1990404162);
            a = ff(a, b, c, d, x[i + 12], 7, 1804603682);
            d = ff(d, a, b, c, x[i + 13], 12, -40341101);
            c = ff(c, d, a, b, x[i + 14], 17, -1502002290);
            b = ff(b, c, d, a, x[i + 15], 22, 1236535329);
            a = gg(a, b, c, d, x[i + 1], 5, -165796510);
            d = gg(d, a, b, c, x[i + 6], 9, -1069501632);
            c = gg(c, d, a, b, x[i + 11], 14, 643717713);
            b = gg(b, c, d, a, x[i + 0], 20, -373897302);
            a = gg(a, b, c, d, x[i + 5], 5, -701558691);
            d = gg(d, a, b, c, x[i + 10], 9, 38016083);
            c = gg(c, d, a, b, x[i + 15], 14, -660478335);
            b = gg(b, c, d, a, x[i + 4], 20, -405537848);
            a = gg(a, b, c, d, x[i + 9], 5, 568446438);
            d = gg(d, a, b, c, x[i + 14], 9, -1019803690);
            c = gg(c, d, a, b, x[i + 3], 14, -187363961);
            b = gg(b, c, d, a, x[i + 8], 20, 1163531501);
            a = gg(a, b, c, d, x[i + 13], 5, -1444681467);
            d = gg(d, a, b, c, x[i + 2], 9, -51403784);
            c = gg(c, d, a, b, x[i + 7], 14, 1735328473);
            b = gg(b, c, d, a, x[i + 12], 20, -1926607734);
            a = hh(a, b, c, d, x[i + 5], 4, -378558);
            d = hh(d, a, b, c, x[i + 8], 11, -2022574463);
            c = hh(c, d, a, b, x[i + 11], 16, 1839030562);
            b = hh(b, c, d, a, x[i + 14], 23, -35309556);
            a = hh(a, b, c, d, x[i + 1], 4, -1530992060);
            d = hh(d, a, b, c, x[i + 4], 11, 1272893353);
            c = hh(c, d, a, b, x[i + 7], 16, -155497632);
            b = hh(b, c, d, a, x[i + 10], 23, -1094730640);
            a = hh(a, b, c, d, x[i + 13], 4, 681279174);
            d = hh(d, a, b, c, x[i + 0], 11, -358537222);
            c = hh(c, d, a, b, x[i + 3], 16, -722521979);
            b = hh(b, c, d, a, x[i + 6], 23, 76029189);
            a = hh(a, b, c, d, x[i + 9], 4, -640364487);
            d = hh(d, a, b, c, x[i + 12], 11, -421815835);
            c = hh(c, d, a, b, x[i + 15], 16, 530742520);
            b = hh(b, c, d, a, x[i + 2], 23, -995338651);
            a = ii(a, b, c, d, x[i + 0], 6, -198630844);
            d = ii(d, a, b, c, x[i + 7], 10, 1126891415);
            c = ii(c, d, a, b, x[i + 14], 15, -1416354905);
            b = ii(b, c, d, a, x[i + 5], 21, -57434055);
            a = ii(a, b, c, d, x[i + 12], 6, 1700485571);
            d = ii(d, a, b, c, x[i + 3], 10, -1894986606);
            c = ii(c, d, a, b, x[i + 10], 15, -1051523);
            b = ii(b, c, d, a, x[i + 1], 21, -2054922799);
            a = ii(a, b, c, d, x[i + 8], 6, 1873313359);
            d = ii(d, a, b, c, x[i + 15], 10, -30611744);
            c = ii(c, d, a, b, x[i + 6], 15, -1560198380);
            b = ii(b, c, d, a, x[i + 13], 21, 1309151649);
            a = ii(a, b, c, d, x[i + 4], 6, -145523070);
            d = ii(d, a, b, c, x[i + 11], 10, -1120210379);
            c = ii(c, d, a, b, x[i + 2], 15, 718787259);
            b = ii(b, c, d, a, x[i + 9], 21, -343485551);
            a = ad(a, olda);
            b = ad(b, oldb);
            c = ad(c, oldc);
            d = ad(d, oldd);
        }
        return rh(a) + rh(b) + rh(c) + rh(d);
    };
    AjaxModule.prototype.getAjaxFuns = function (apis, prefixUrl) {
        // this.ajaxFuncs = this.ajaxFuncs || {};
        var ajaxFuncs = {};
        for (var key in apis) {
            ajaxFuncs[key] = this.ajaxFunc(apis[key], prefixUrl);
        }
        return ajaxFuncs;
    };
    return AjaxModule;
}());
exports.default = AjaxModule;
